import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Create = () => import('./views/Create')

const ROUTE_NAME = 'profile:marketing-campaign:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const CREATE = p('create')
const DISPLAY = p('display')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
    route('create/', Create, CREATE, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
    route(':id/', Display, DISPLAY, {
      props: true,
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
  ]
}
